import cookieStorage from './cookieStorage'

export { setItem, getItem, removeItem, removeAll } from './cookieStorage'
export default cookieStorage
